<template>
    <div class="app">
        <!-- <jycheader :navIndex="0"></jycheader> -->
        <jycheader></jycheader>
        <div class="choose-city-box">
            <div class="choose-city-banner">
                <img
                    style="width:100%;height:auto"
                    src="../../assets/image/img/newimg/bg.png"
                    alt=""
                />
            </div>
            <div
                class="dis-cen"
                style="background-color: #F1F1F1;"
            >
                <div class="choose-new-box dis-cen">
                    <div class="header_input">
                        <div class="input-box dis">
                            <div class="input-box-inputbox dis">
                                <div><img
                                        class="hea-img"
                                        src="../../assets/image/iocn/sousuo.png"
                                    /></div>
                                <input
                                    class="hea-input"
                                    style="outline:none;"
                                    placeholder="搜索"
                                    v-model="searchValue"
                                    @keydown.enter.stop="user_search"
                                />
                            </div>
                            <div
                                class="header_inputs"
                                @click="user_search"
                            >
                                搜索
                            </div>
                        </div>
                        <div class="search-hot dis">
                            <div>热门搜索:&nbsp;&nbsp;&nbsp;</div>
                            <div
                                style="margin-right: 10px;cursor:pointer"
                                v-for="(hotItem, hotIndex) in hotcityList"
                                :key="hotIndex"
                                @click="popoverClick(hotItem.id, hotItem.name, hotItem.existName, 1)"
                            >{{hotItem.name}}</div>


                        </div>
                    </div>

                    <div class="choose-box">
                        <!--??? 定位功能-->
                        <div class="choose-box-p">当前城市</div>
                        <div class="dis">
                            <div class="choose-box-city">
                                <div class="choose-box-qu"><span
                                        @click="popoverClick(sideCity.id, sideCity.name, sideCity.existName, 1)"
                                        :class="[sideCity.existName == '开通'?'exist-color':'', sideCity.v_isact == 1?'act-color':'']"
                                    >{{sideCity.name}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div class="choose-box">
                        <div class="choose-box-p">当前区县</div>
                        <div class="dis">
                            <div class="choose-box-city">
                                <div
                                    class="choose-box-qu"
                                    style="margin-bottom: 20px;margin-right: 20px"
                                    v-for="(itemQu, indexQu) in sideCity.children"
                                    :key="indexQu"
                                ><span
                                        @click="chooseSelectCity(sideCity.id, sideCity.name, sideCity.existName, itemQu.id, itemQu.name, itemQu.existName)"
                                        :class="[itemQu.existName == '开通'?'exist-color':'', sideCity.v_isact == 1?'act-color':'']"
                                    >{{itemQu.name}}</span></div>
                            </div>
                        </div>
                    </div>
                    <div
                        class="choose-box"
                        v-for="(item, index) in cityData"
                        :key="index"
                    >
                        <div class="choose-box-p">{{item.name}}</div>
                        <div class="dis">
                            <div
                                class="choose-box-city"
                                v-for="(itemTwo, indexTwo) in item.children"
                                :key="indexTwo"
                            >
                                <el-popover
                                    v-if="itemTwo.children.length > 0"
                                    placement="bottom"
                                    title=""
                                    width="960"
                                    trigger="hover"
                                    content=""
                                    @show="popoverClick(itemTwo.id, itemTwo.name, itemTwo.existName, '', 1)"
                                >
                                    <!--鼠标触发 trigger="hover" trigger="click" -->
                                    <div class="dis">
                                        <div
                                            class="choose-box-qu"
                                            style="margin-bottom: 20px;margin-right: 20px"
                                            @click="popoverClick(itemTwo.id, itemTwo.name, itemTwo.existName, 1)"
                                            :class="itemTwo.existName == '开通'?'exist-color':''"
                                        >{{itemTwo.name}}</div>
                                        <div
                                            v-for="(itemThree, indexThree) in itemTwo.children"
                                            :key="indexThree"
                                        >
                                            <div
                                                class="choose-box-qu"
                                                style="margin-bottom: 20px;margin-right: 20px"
                                                @click="chooseSelectCity(itemTwo.id, itemTwo.name, itemTwo.existName, itemThree.id, itemThree.name, itemThree.existName)"
                                                :class="itemThree.existName == '开通'?'exist-color':''"
                                            >{{itemThree.name}}</div>
                                        </div>
                                    </div>
                                    <el-button slot="reference"><span :class="[itemTwo.existName == '开通'?'exist-color':'', itemTwo.v_isact == 1?'act-color':'']">{{itemTwo.name}}</span></el-button>
                                </el-popover>
                                <div
                                    v-else
                                    class="choose-box-qu"
                                ><span
                                        @click="popoverClick(itemTwo.id, itemTwo.name, itemTwo.existName)"
                                        :class="[itemTwo.existName == '开通'?'exist-color':'', itemTwo.v_isact == 1?'act-color':'']"
                                    >{{itemTwo.name}}</span></div>
                                <!--鼠标触发 @mouseover="popoverClick(itemTwo.id, itemTwo.name, itemTwo.existName)"-->

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <jycfooter></jycfooter>
    </div>
</template>

<script>
    import jycheader from "../header.vue"
    import jycfooter from "../bottom.vue"

    export default
    {
        data()
        {
            return {
                searchValue: '',
                //+------------------------------------
                sideCity: [], // 当前城市，及区县城市
                sideIndex: 0,
                hotcityList: [
                    { id: 243, name: '北京市', existName: '' },
                    { id: 265, name: '上海市', existName: '' },
                    // { id: 2138, name: '广州市', existName: '' },
                    // { id: 2162, name: '深圳市', existName: '' },
                    // { id: 273, name: '杭州市', existName: '' },
                    // { id: 2428, name: '成都市', existName: '' }, // ! 取不到 existName，需多级遍历才能取到
                    { id: 272, name: '重庆市', existName: '' },
                ], // 热门城市
                cityData: [],
            }
        },
        components:
        {
            jycheader,
            jycfooter,
        },
        created()
        {
            this.getCityApi();
        },
        methods:
        {
            async getCityApi()
            {
                this.$loading()
                localStorage.removeItem( 'city_tree' )
                // !!! 因为城市的开通字段是多变的，所以进入页面即请求，拉取最新数据
                let { data } = await this.$api.order.getcityTree()
                let { code, result } = data

                if ( code == 0 )
                {
                    for ( let i = 0; i < result.length; i++ )
                    {
                        let obj = result[ i ].children
                        for ( let j = 0; j < obj.length; j++ )
                        {
                            obj[ j ][ 'v_isact' ] = 0
                        }

                        for ( let z = 0; z < this.hotcityList.length; z++ )
                        {
                            let objId = result[ i ].id
                            let id = this.hotcityList[ z ].id
                            if ( objId == id ) this.hotcityList[ z ].existName = result[ i ].existName
                        }
                    }
                    this.cityData = result
                    this.sideCity = result[ 0 ].children[ 6 ]
                    // console.log( this.cityData )
                    // console.log( this.sideCity )
                    // console.log( this.hotcityList )
                    localStorage.setItem( "city_tree", JSON.stringify( result ) ) // 其它功能备用
                }
                this.$loading().close()
            },
            popoverClick( id, name, existName, val = '', vlaue = '' )
            {
                if ( existName == '未开通' && !vlaue )
                {
                    let a = name + '，未开通'
                    this.$message(
                    {
                        message: a,
                        type: 'warning'
                    } );
                    return
                }


                if ( val )
                {
                    let msg = '您选择的城市为：' + name
                    this.$message(
                    {
                        message: msg,
                        type: 'success'
                    } );

                    let a = { twoId: id, twoName: name, threeId: -1, threeName: '', LngLatAddress:'' }
                    localStorage.setItem( "cityname", JSON.stringify( a ) )
                    this.$router.push( { path: "/", query: { cityname: name } } )
                }
            },
            chooseSelectCity( twoId, twoName, twoExistName, threeId, threeName, threeExistName, )
            {
                if ( threeExistName == '未开通' )
                {
                    let a = threeName + '，未开通'
                    this.$message(
                    {
                        message: a,
                        type: 'warning'
                    } );
                    return
                }

                let msg = '您选择的城市为：' + twoName + '-' + threeName
                this.$message(
                {
                    message: msg,
                    type: 'success'
                } );

                let val = { twoId: twoId, twoName: twoName, threeId: threeId, threeName: threeName }
                localStorage.setItem( "cityname", JSON.stringify( val ) )
                let name = twoName + '-' + threeName
                this.$router.push( { path: "/", query: { cityname: name } } )
            },
            user_search()
            {
                console.log( this.searchValue )
            }
        },
    }
</script>



<style scoped="scoped">
    @import '../../assets/style/base.css';

    .header_input {
        margin: 50px 0 80px 0
    }

    .input-box-inputbox {
        width: 29.0625rem;
        height: 2.5rem;
        border: 2px solid #11D165;
        border-radius: 5px 0 0 5px;
        outline: none;
        padding-left: 1rem;
    }

    .choose-box-city>>>.el-button {
        display: inline-block;
        line-height: 1;
        white-space: nowrap;
        cursor: pointer;
        background: #F7F7F7;
        border: none;
        color: #434343;
        -webkit-appearance: none;
        text-align: center;
        box-sizing: border-box;
        outline: 0;
        margin: 0;
        transition: .1s;
        font-weight: 500;
        padding: 12px 20px;
        font-size: 16px;
        border-radius: 4px;
    }

    .act-color {
        color: #11D165
    }

    .exist-color {
        color: #f76805
    }

    .header_input>img {
        margin-right: 6px;
    }

    .header_input span {
        color: #404040;
        font-size: 18px;
        margin-right: 6px;
        font-weight: 400;
        cursor: pointer;
    }

    .header_inputs {
        width: 4.8125rem;
        height: 2.5rem;
        background: #11D165;
        border-radius: 0 3px 3px 0;
        cursor: pointer;
        color: #ffffff;
        font-size: 1rem;
        text-align: center;
        line-height: 2.5rem;
    }

    .search-hot {
        width: 33.875rem;
        margin: 0.5rem 0 0 0;
        color: #666666;
        font-size: 12px;
        font-weight: 400;
    }
</style>